// extracted by mini-css-extract-plugin
module.exports = {"banner":"Banner_banner__3t_cK","flex":"Banner_flex__3QKxx","title":"Banner_title__1Q9Km","paragraph":"Banner_paragraph__3Bado","link":"Banner_link__34UCn"};